import { render, staticRenderFns } from "./service_list.vue?vue&type=template&id=2c14f66a&"
import script from "./service_list.vue?vue&type=script&lang=js&"
export * from "./service_list.vue?vue&type=script&lang=js&"
import style0 from "./service_list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../vue/rewards-admin-portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports